import { Check, Wand2 } from "lucide-react";
import { STYLES } from "@/data/site";

export const StylePicker = ({ value, onChange }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
    {STYLES.map((s) => {
      const active = value === s.id;
      return (
        <button
          key={s.id}
          type="button"
          data-testid={`style-picker-${s.id}`}
          onClick={() => onChange(s.id)}
          className={`group relative h-28 rounded-2xl overflow-hidden text-left ring-1 transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5 ${
            active ? "ring-2 ring-[#d5d9df] shadow-[0_0_30px_rgba(190,197,208,0.6)]" : "ring-white/10"
          }`}
        >
          {s.img ? (
            <img src={s.img} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
          ) : (
            <div className="absolute inset-0 bg-gradient-to-br from-[#3b4049]/40 to-[#0b0b0d] grid place-items-center">
              <Wand2 className="h-7 w-7 text-[#e6e8ec] -mt-6" />
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
          <span className="absolute bottom-3 left-3 right-3 text-sm font-semibold">{s.name}</span>
          {active && (
            <span className="absolute top-2.5 right-2.5 h-6 w-6 rounded-full bg-[#3b4049] grid place-items-center">
              <Check className="h-3.5 w-3.5" />
            </span>
          )}
        </button>
      );
    })}
  </div>
);
